// eslint-disable-next-line import/prefer-default-export
export const tabViewDuoCare = [
  { title: 'Lớp Duo', icon: '', disable: false },
  { title: 'Tự học', icon: '', disable: false },
];
export const CARE_DUO_CLASSES = [
  {
    text: 'Lớp 9',
    value: 9,
  },
  {
    text: 'Lớp 8',
    value: 8,
  },
  {
    text: 'Lớp 7',
    value: 7,
  },
  {
    text: 'Lớp 6',
    value: 6,
  },
  {
    text: 'Lớp 5',
    value: 5,
  },
  {
    text: 'Lớp 4',
    value: 4,
  },
  {
    text: 'Lớp 3',
    value: 3,
  },
  {
    text: 'Lớp 2',
    value: 2,
  },
  {
    text: 'Lớp 1',
    value: 1,
  },
];
export const STATUS_INDEX_COLOR = [
  '739A77',
  '4B6AFE',
  'FD9095',
  '6CABCE',
  '82739A',
  'A6E8C8',
  'D95335',
  'A76FC9',
  '9AA654',
  'D8BA27',
  'F1883C',
  '739A95',
  '7CD0FF',
  'B04B74',
  'A08873',
  'FFBCA5',
  '238AA6',
  'EBA5B8',
  'AB9CD6',
  '2350A6',
  'A5EBE7',
];
export const ORDER_DEPOSIT_TYPE = 1;
export const ORDER_FINISH_TYPE = 2;
export const namesOrderContactStatusTc = ['GIAO THÀNH CÔNG', 'ĐÃ NHẬN COD', 'ĐÃ NHẬN BANK'];
export const PERMISSION_TO_ACTION = {
  PERIODICALLY_CARE: [
    {
      permission: 'periodic-care-tab-early-extend_read',
      title: 'Gia hạn sớm',
      type: 'move_to_early_extension',
    },
    {
      permission: 'periodic-care-tab-change-teacher_read',
      title: 'Chuyển quản lý học tập',
      type: 'change_homeroom_teacher',
    },
    {
      permission: 'periodic-care-tab-move-to-general_read',
      title: 'Chuyển vào kho chung',
      type: 'move_to_general_tab',
    },
  ],
  EXTEND: [
    {
      permission: 'extend-tab-early-extend_read',
      title: 'Gia hạn sớm',
      type: 'move_to_early_extension',
    },
    {
      permission: 'extend-tab-change-teacher_read',
      title: 'Chuyển quản lý học tập',
      type: 'change_homeroom_teacher',
    },
  ],
  GENERAL_TAB: [
    {
      permission: 'general-tab-change-teacher_read',
      title: 'Chuyển quản lý học tập',
      type: 'change_homeroom_teacher',
    },
    {
      permission: 'general-tab-move-to-periodic-care_read',
      title: 'Chuyển sang CSĐK',
      type: 'move_to_periodically_care_tab',
    },
  ],
};
export const DUO_TOP_CONTENT_ACTIVE_TAB = {
  HOMEWORK: 0,
  TEST: 1,
};
